import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-rp-advanced-features-section',
  templateUrl: './advanced-features-section.component.html',
  styleUrls: ['./advanced-features-section.component.scss'],
})
export class AdvancedFeaturesSectionComponent implements AfterViewInit {
  @ViewChild('swiper') swiperEl!: ElementRef<any>;
  @ViewChild('prevBtn') prevBtn!: ElementRef<HTMLElement>;
  @ViewChild('nextBtn') nextBtn!: ElementRef<HTMLElement>;

  features = [
    {
      titleKey: 'recruiterProgram.advancedFeatures.aiAgent.title',
      descKey: 'recruiterProgram.advancedFeatures.aiAgent.description',
      imageName: 'feature-1',
    },
    {
      titleKey: 'recruiterProgram.advancedFeatures.automation.title',
      descKey: 'recruiterProgram.advancedFeatures.automation.description',
      imageName: 'feature-2',
    },
    {
      titleKey: 'recruiterProgram.advancedFeatures.analysis.title',
      descKey: 'recruiterProgram.advancedFeatures.analysis.description',
      imageName: 'feature-3',
    },
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  async ngAfterViewInit(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;
    const {register} = await import('swiper/element/bundle');
    register();
    await customElements.whenDefined('swiper-container');
    const isRtl = this.document.documentElement.dir === 'rtl';
    const el = this.swiperEl.nativeElement;
    Object.assign(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,
      centeredSlides: false,
      navigation: {
        prevEl: isRtl ? this.nextBtn.nativeElement : this.prevBtn.nativeElement,
        nextEl: isRtl ? this.prevBtn.nativeElement : this.nextBtn.nativeElement,
      },
    });
    el.initialize();
  }
}
